import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=2138e316&scoped=true&"
import script from "./SelectGroup.vue?vue&type=script&lang=js&"
export * from "./SelectGroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=2138e316&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2138e316",
  null
  
)

export default component.exports